import { call, put, takeLatest } from "redux-saga/effects";
import { getorderRetrieveDataFailure, getorderRetrieveDataSuccess, orderRetrieveDataRequest } from "../slice/orderRetrieveSlice";
import { config } from "../../../config/global";
import i18n from "../../../i18n";
import api from "../../../config/api";
const fetchOrderRetrieveData = async payload => {
  const ORDER_RETRIEVE_API_URL = config.ORDER_RETRIEVE;
  const lang = i18n.language ?? "en-th";
  const splittedLang = lang?.split("-");
  const retrievePayload = {
    ...payload,
    countryCode: splittedLang?.[1],
    languageCode: splittedLang?.[0],
    user: "website",
    userGroup: "online"
  };
  const data = {
    mode: "no-cors",
    headers: {
      "Accept-Language": `${i18n.language}`,
      "Content-Type": "application/json"
    },
    loader: true,
    isOrderRetrieve: true
  };
  const response = await api.post(`${ORDER_RETRIEVE_API_URL}`, retrievePayload, data);
  return response;
};
function* getOrderRetrieveData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchOrderRetrieveData, payload);
    if (response?.data?.cancelledOrder) {
      throw {
        response: {
          data: {
            errors: [{
              code: "51001",
              title: "Order Not Found",
              detail: "Please enter a valid PNR"
            }]
          },
          config: {
            url: "order/retrieve-booking"
          }
        }
      };
    } else {
      yield put(getorderRetrieveDataSuccess(response.data));
    }
  } catch (error) {
    yield put(getorderRetrieveDataFailure(error));
  }
}
export function* watchOrderRetrieveData() {
  yield takeLatest(orderRetrieveDataRequest.type, getOrderRetrieveData);
}